export const removeParamFromUrl = (param) => {
  //remove param from url
  const url = new URL(window.location.href);
  url.searchParams.delete(param);
  window.history.replaceState({}, '', url.toString());
}